module.exports = __webpack_public_path__ + "img/fonfo-informatica.d2e8cfff.jpg";